import Constants from 'expo-constants'

const oneSignalAppId = "682340db-5e0b-4f26-b338-ce9cb071cf32";
const urlStart = "https://brocashamburgueria.web.app/";

export function sendNotification(title,msg){
       
        // await fetch("https://onesignal.com/api/v1/notifications", {
        //     body: JSON.stringify({
        //         "app_id": Constants.manifest.extra.oneSignalAppId,
        //         "contents": {"en": `${msg}`},
        //         "headings": {"en": `${title}`},
        //         "included_segments": ["Subscribed Users"],
        //         "wp_wns_sound": "notification.wav",
        //         "url": `${Constants.manifest.extra.urlStart}Painel/`
        //     }),
        //     headers: {
        //         "authorization": "Basic NjhhNWIzOTQtMjI3Yy00ZjkwLTlhZjItYTQxNjEwOTg5NGY1",
        //         "content-type": "application/json; charset=utf-8"
        //     },
        //     method: "POST"
        // }).then((value) => console.log('sucess send',value))
        // .catch((err) => console.log("erro send",err))
        const options = {
            method: 'POST',
            headers: {
              accept: 'application/json',
              Authorization: 'Basic NDQyNTBjZjItM2Q4OC00ZTVkLThlOWQtZmQ3ZmNkNmU1MzBi',
              'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
              app_id: `${oneSignalAppId}`,
              included_segments: ['Adm'],
              contents: {en: `${msg}`}, 
              name: `${title}`,
              headings: {"en": `${title}`},
              wp_wns_sound: 'notification.wav',
              url: `${urlStart}Painel/`
            })
          };
          
          fetch('https://onesignal.com/api/v1/notifications', options)
            .then(response => response.json())
            .then(response => console.log(response))
            .catch(err => console.error(err));
        
        
    
}